var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.8l-2.9-3c-.1-.1-.1-.5 0-.7L3 .1c.2-.2.5-.2.7 0 .3.3.3.6.1.8L1.7 3h6.7c.4 0 .6.2.6.5s-.2.5-.5.5H1.7l2 2.1c.3.2.3.5.1.7-.1.1-.3.2-.4.2-.1 0-.3-.1-.4-.2z"
  })));
}
export default SvgBack;